import { dealerActiveAuctionSearchTermsAtom } from "@/src/state/dealer/dealerActiveAuctionSearchTermsAtom";
import { dealerEndedAuctionSearchTermsAtom } from "@/src/state/dealer/dealerEndedAuctionSearchTermsAtom";
import { dealerSearchBarContentAtom } from "@/src/state/dealer/dealerSearchBarContentAtom";

import { useResetAtom } from "jotai/utils";

export const useResetSearchTerms = () => {
  const resetActiveSearchFilterAtom = useResetAtom(
    dealerActiveAuctionSearchTermsAtom
  );

  const resetEndedSearchFilterAtom = useResetAtom(
    dealerEndedAuctionSearchTermsAtom
  );

  const resetSearchBarContent = useResetAtom(dealerSearchBarContentAtom);

  const resetSearchTerms = () => {
    resetSearchBarContent();
    setTimeout(() => {
      resetActiveSearchFilterAtom();
      resetEndedSearchFilterAtom();
    }, 500);
  };
  return resetSearchTerms;
};
